import { create } from 'zustand';

interface DebugState {
  physicsDebug: boolean;
  postprocessing: boolean;
  showPerf: boolean;
  showHud: boolean;
  setPhysicsDebug: (v: boolean) => void;
  setPostprocessing: (v: boolean) => void;
  setShowPerf: (v: boolean) => void;
  setShowHud: (v: boolean) => void;
}

export const useDebugStore = create<DebugState>((set) => ({
  physicsDebug: false,
  postprocessing: true,
  showPerf: false,
  showHud: true,
  setPhysicsDebug: (physicsDebug) => set({ physicsDebug }),
  setPostprocessing: (postprocessing) => set({ postprocessing }),
  setShowPerf: (showPerf) => set({ showPerf }),
  setShowHud: (showHud) => set({ showHud }),
}));
